module.exports = __webpack_public_path__ + "trend.1018fecd98651a41e2c2a17ab9db0767.png";